import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AssessmentRef } from '../../utils/refs';
import { setDoc } from 'firebase/firestore';
import { getCurrentTimestamp, captureError } from '../../utils';
import { writeAssessmentActivityLog } from './useUpdateAssessmentActivityLog';

const updateMentalityAssessment = async (assessmentID, questionID, changes) => {
  const docRef = AssessmentRef(assessmentID);

  try {
    await setDoc(
      docRef,
      {
        responses: {
          [`${questionID}`]: changes
        },
        lastModified: getCurrentTimestamp()
      },
      { merge: true }
    );
  } catch (err) {
    captureError(err, { assessmentID, questionID, write: 'response' });
    writeAssessmentActivityLog(assessmentID, questionID, 'responseWriteFailed', { message: err?.message || String(err) });
  }

  return { changes };
};

export default function useUpdateMentalityAssessment(assessmentID) {
  const UpdateMentalityAssessmentMutation = ({ questionID, changes }) => {
    return updateMentalityAssessment(assessmentID, questionID, changes);
  };

  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: UpdateMentalityAssessmentMutation,
    onError: (error, variables) => {
      captureError(error, { assessmentID, ...variables, write: 'response' });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['mentalityAssessment'] });
    }
  });
}
